import { EventEmitter, Injectable, ɵɵdefineInjectable, Component, HostListener, Input, Pipe, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BehaviorSubject, Subject } from 'rxjs';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/nav-bar-mensajes.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//import {  } from "rxjs";
class NavBarService {
    constructor() {
        this.Deleted = new EventEmitter();
        this.OpenCloseNav = (/**
         * @return {?}
         */
        () => {
            if (!this.Open) {
                document.getElementById("mySidenav").style.width = "320px";
                document.getElementById("main").style.marginLeft = "320px";
                this.Open = true;
            }
            else {
                document.getElementById("mySidenav").style.width = "0";
                document.getElementById("main").style.marginLeft = "0";
                this.Open = false;
            }
        });
        this.Mensajes = [];
        this.Open = false;
        this.ActivarMenu = false;
        this.MensajeObservable = new BehaviorSubject(null);
        this.MensajeObservableClear = new Subject();
        this.SrcDefault();
    }
    /**
     * @return {?}
     */
    SrcDefault() {
        this.Src = "alarm-006"; //"icons/006-alarm.png";
    }
    /**
     * @return {?}
     */
    SrcNewMessage() {
        this.Src = "alarm"; //"icons/alarm.png";
    }
    /**
     * @param {?} mensaje
     * @return {?}
     */
    AddMensajes(mensaje) {
        //this.Mensajes.push(mensaje);
        if (mensaje == null)
            return;
        this.MensajeObservable.next(mensaje);
    }
    /**
     * @return {?}
     */
    ClearMensajes() {
        return this.MensajeObservableClear;
    }
    /**
     * @return {?}
     */
    Clear() {
        this.MensajeObservableClear.next(true);
    }
    /**
     * @return {?}
     */
    GetMensaje() {
        return this.MensajeObservable;
    }
    /**
     * @return {?}
     */
    GetMensajesArray() {
        return this.Mensajes;
    }
    /**
     * @return {?}
     */
    ActivarMenuNavBar() {
        setTimeout((/**
         * @return {?}
         */
        () => {
            this.ActivarMenu = true;
        }), 3000);
    }
    /**
     * @return {?}
     */
    DesactivarMenuNavBar() {
        this.ActivarMenu = false;
    }
    /**
     * @param {?} mensajes
     * @param {?} key
     * @return {?}
     */
    GetMensajesUsuario(mensajes, key) {
        //let mensajes = this.GetMensajesLocalStorage(key).concat(arrayMensajes);
        if (mensajes.length > 0) {
            mensajes.forEach((/**
             * @param {?} f
             * @return {?}
             */
            f => {
                this.AddMensajes(f);
            }));
        }
        localStorage.setItem(`mensajes.${key}`, JSON.stringify(mensajes));
    }
    /**
     * @param {?} key
     * @return {?}
     */
    GetDataMensajes(key) {
        /** @type {?} */
        let promise = new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            /** @type {?} */
            let request = indexedDB.open('mensajes', 2);
            request.onupgradeneeded = (/**
             * @param {?} e
             * @return {?}
             */
            function (e) {
                if (request.transaction.objectStoreNames.length == 0) {
                    e.target.transaction.abort();
                    resolve([]);
                }
                //dbExists = false;
            });
            request.onsuccess = (/**
             * @param {?} event
             * @return {?}
             */
            (event) => {
                /** @type {?} */
                let db = request.result;
                db.onerror = (/**
                 * @param {?} event
                 * @return {?}
                 */
                (event) => {
                    console.log(event);
                });
                /** @type {?} */
                let transaccion = null;
                try {
                    transaccion = db.transaction('mensaje.' + key, 'readwrite');
                }
                catch (ex) {
                    console.debug(ex);
                }
                if (transaccion != null) {
                    /** @type {?} */
                    let store = transaccion.objectStore('mensaje.' + key);
                    /** @type {?} */
                    let all = store.getAll();
                    all.onsuccess = (/**
                     * @param {?} data
                     * @return {?}
                     */
                    (data) => {
                        /** @type {?} */
                        let mensajes = data.target.result;
                        if (mensajes.length > 0) {
                            store.clear();
                            //indexedDB.open().transaction.objectStore().clear
                        }
                        resolve(mensajes);
                    });
                }
                else {
                    resolve([]);
                }
            });
        }));
        return promise;
    }
    /**
     * @param {?} key
     * @return {?}
     */
    GetMensajesLocalStorage(key) {
        /** @type {?} */
        let mensajes = localStorage.getItem(`mensajes.${key}`);
        /** @type {?} */
        let mensajesArray = JSON.parse(mensajes);
        if (Array.isArray(mensajesArray)) {
            return mensajesArray;
        }
        return [];
    }
    /**
     * @param {?} id
     * @return {?}
     */
    OnDeleted(id) {
        this.Deleted.emit(id);
    }
}
NavBarService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
NavBarService.ctorParameters = () => [];
/** @nocollapse */ NavBarService.ngInjectableDef = ɵɵdefineInjectable({ factory: function NavBarService_Factory() { return new NavBarService(); }, token: NavBarService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    NavBarService.prototype.Open;
    /**
     * @type {?}
     * @private
     */
    NavBarService.prototype.ActivarMenu;
    /** @type {?} */
    NavBarService.prototype.Src;
    /**
     * @type {?}
     * @private
     */
    NavBarService.prototype.Mensajes;
    /**
     * @type {?}
     * @private
     */
    NavBarService.prototype.MensajeObservable;
    /**
     * @type {?}
     * @private
     */
    NavBarService.prototype.MensajeObservableClear;
    /** @type {?} */
    NavBarService.prototype.Deleted;
    /** @type {?} */
    NavBarService.prototype.OpenCloseNav;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/nav-bar-mensajes.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//import { USER_AUTH, IUserAuth } from 'vesta-authentication';
class NavbarMensajesComponent {
    //Mensajes: Array<string>;
    /**
     * @param {?} navBarService
     */
    constructor(navBarService) {
        this.navBarService = navBarService;
        this.Mensajes = this.navBarService.GetMensajesArray();
        this.CloseNav = (/**
         * @return {?}
         */
        () => {
            this.navBarService.OpenCloseNav();
        });
    } //, @Inject(USER_AUTH) private user: IUserAuth
    //, @Inject(USER_AUTH) private user: IUserAuth
    /**
     * @param {?} event
     * @return {?}
     */
    onResize(event) {
        event.target.innerWidth;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.Search = "";
        //if (this.key == null) throw 'Defina un valor para Input key, <nav-bar [key]="value"></nav-bar> '
        //this.Mensajes = [];
        this.navBarService.GetMensaje().subscribe((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            if (response == null)
                return;
            this.Mensajes.push(response);
            this.navBarService.SrcNewMessage();
            this.Search = "";
            localStorage.setItem(`mensajes.${this.key}`, JSON.stringify(this.Mensajes)); //this.user.Id
        }));
        this.navBarService.ClearMensajes().subscribe((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            this.Mensajes = [];
            this.navBarService.SrcDefault();
        }));
        //this.user.User.then(async user => {
        //  if (user.Id == null) return void 0;
        //  let arrayMensajes = await this.GetDataMensajes();
        //  if (Array.isArray(arrayMensajes)) {
        //    this.Mensajes = this.GetMensajesLocalStorage().concat(arrayMensajes);
        //    if (this.Mensajes.length > 0) this.navBarService.SrcNewMessage();
        //    localStorage.setItem(`mensajes.${this.user.Id}`, JSON.stringify(this.Mensajes));
        //  };
        //})   
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        $('.sidebar').hover((/**
         * @return {?}
         */
        function () {
            $(".sidebar").removeClass("compact");
        }));
        $('.sidebar').mouseleave((/**
         * @return {?}
         */
        function () {
            $(".sidebar").addClass("compact");
        }));
    }
    /**
     * @param {?} index
     * @return {?}
     */
    DeleteMensaje(index) {
        /** @type {?} */
        let mensaje = this.Mensajes[index];
        this.Mensajes.splice(index, 1);
        localStorage.setItem(`mensajes.${this.key}`, JSON.stringify(this.Mensajes));
        this.navBarService.OnDeleted(mensaje.Id);
        if (this.Mensajes.length == 0) {
            this.navBarService.SrcDefault();
        }
    }
    /**
     * @param {?} evento
     * @return {?}
     */
    EventClick(evento) {
        console.log(evento);
    }
}
NavbarMensajesComponent.decorators = [
    { type: Component, args: [{
                selector: "nav-bar",
                template: "<div id=\"mySidenav\" class=\"sidenav grid condensed\">\r\n  <br />\r\n  <div class=\"row\">\r\n    <div class=\"cell\">\r\n      <div class=\"input-control text full-size\">\r\n        <input type=\"text\" placeholder=\"Buscar..\" [(ngModel)]=\"Search\" style=\"padding: 0 !important;\"/>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  \r\n  <a href=\"javascript:void(0)\" class=\"closebtn\" (click)=\"CloseNav()\">&times;</a>\r\n\r\n  <div class=\"scrollAuto\">\r\n    <div class=\"row cells12\" *ngFor=\"let item of Mensajes | filterBy:'Mensaje':Search; let i = index\">\r\n      <div class=\"cell colspan11\">\r\n        <a [ngClass]=\"{successNavbar: item.Success, alertNavbar: !item.Success}\" (click)=\"EventClick(item.Evento)\">{{item.Mensaje}}</a>\r\n      </div>\r\n      <div class=\"cell\">\r\n        <button class=\"closebtnrow buttonnav\" (click)=\"DeleteMensaje(i)\">&times;</button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  \r\n\r\n</div>\r\n",
                styles: [".sidenav{height:100%;width:0;position:fixed;z-index:1;top:0;left:0;background-color:#111;-webkit-transition:.5s;transition:.5s;padding-top:90px}.sidenav a{padding:8px 8px 8px 5px;text-decoration:none;font-size:14px;color:#fff;display:block;-webkit-transition:.3s;transition:.3s}.offcanvas a:focus,.sidenav a:hover{color:#f1f1f1}.sidenav .closebtn{position:absolute;top:50px;right:0;font-size:36px;margin-left:50px}.sidenav .closebtnrow{right:0;font-size:36px;margin-left:0}.sidenav .buttonnav{background:0 0;border:0;color:#fff;font-size:larger;display:block;width:100%;border:none;text-align:center}.successNavbar{color:#4caf50!important}.alertNavbar{color:#f44336!important}#main{-webkit-transition:margin-left .5s;transition:margin-left .5s}@media screen and (max-height:450px){.sidenav{padding-top:15px}.sidenav a{font-size:18px}}.scrollAuto{height:80vh;overflow-y:auto}"]
            }] }
];
/** @nocollapse */
NavbarMensajesComponent.ctorParameters = () => [
    { type: NavBarService }
];
NavbarMensajesComponent.propDecorators = {
    onResize: [{ type: HostListener, args: ['window:resize', ['$event'],] }],
    key: [{ type: Input, args: ["key",] }]
};
if (false) {
    /** @type {?} */
    NavbarMensajesComponent.prototype.Mensajes;
    /** @type {?} */
    NavbarMensajesComponent.prototype.Search;
    /** @type {?} */
    NavbarMensajesComponent.prototype.key;
    /** @type {?} */
    NavbarMensajesComponent.prototype.CloseNav;
    /**
     * @type {?}
     * @private
     */
    NavbarMensajesComponent.prototype.navBarService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/filter.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FilterByPipe {
    /**
     * @param {?} value
     * @param {?} key
     * @param {?} term
     * @return {?}
     */
    transform(value, key, term) {
        return value.filter((/**
         * @param {?} item
         * @return {?}
         */
        (item) => {
            if (item.hasOwnProperty(key)) {
                if (term) {
                    /** @type {?} */
                    let regExp = new RegExp("\\b" + term, "gi");
                    return regExp.test(item[key]);
                }
                else {
                    return true;
                }
            }
            else {
                return false;
            }
        }));
    }
}
FilterByPipe.decorators = [
    { type: Pipe, args: [{
                name: "filterBy",
                pure: false
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/nav-bar-mensajes.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//import { VestaAuthenticationUserModule } from 'vesta-authentication';
class NavBarMensajesModule {
}
NavBarMensajesModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, FormsModule],
                declarations: [NavbarMensajesComponent, FilterByPipe],
                exports: [NavbarMensajesComponent, FilterByPipe],
                providers: [NavBarService]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/nav-bar-mensajes.object.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MensajeNavBar {
    constructor() {
        this.Mensaje = "";
        this.Success = false;
        this.Evento = null;
        this.Id = '00000000-0000-0000-0000-000000000000';
    }
    /**
     * @param {?} id
     * @param {?} mensaje
     * @param {?=} success
     * @param {?=} evento
     * @return {?}
     */
    static GetMensajeNavBar(id, mensaje, success = false, evento = null) {
        /** @type {?} */
        var obj = new MensajeNavBar();
        obj.Mensaje = mensaje;
        obj.Success = success;
        obj.Evento = evento;
        obj.Id = id;
        return obj;
    }
}
if (false) {
    /** @type {?} */
    MensajeNavBar.prototype.Mensaje;
    /** @type {?} */
    MensajeNavBar.prototype.Success;
    /** @type {?} */
    MensajeNavBar.prototype.Evento;
    /** @type {?} */
    MensajeNavBar.prototype.Id;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: nav-bar-mensajes.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { MensajeNavBar, NavBarMensajesModule, NavBarService, NavbarMensajesComponent, FilterByPipe as ɵa };
//# sourceMappingURL=nav-bar-mensajes.js.map
